const actionPrefix = (actionType) => `ErrorPage/${actionType}`;

export const SET_ERROR_STATUS = actionPrefix('SET_ERROR_STATUS');
const setErrorStatus = (errorType) => ({
  type: SET_ERROR_STATUS,
  payload: errorType,
});

export const CLEAR_ERROR_STATUS = actionPrefix('CLEAR_ERROR_STATUS');
const clearErrorStatus = () => ({ type: CLEAR_ERROR_STATUS });

export const errorPageActions = {
  setErrorStatus,
  clearErrorStatus,
};
